// Iconițe — Font Awesome 6 Free, exact ca la ScalpX.
//
// Numele `fa-*` sunt luate una la una din bundle-ul lor, ca iconițele să fie identice.
// Uneltele de desen fac excepție: acolo ScalpX folosește SVG-uri proprii (`chart-tool-svg`),
// pentru că Font Awesome nu are un „luč orizontal" sau un „risc/profit". Le desenăm și noi.

/** Numele semantice folosite în cod -> clasa Font Awesome reală. */
const FA = {
  // taburi de screener (identice cu ScalpX)
  eye: 'fa-solid fa-eye',
  grid: 'fa-solid fa-table-cells-large',
  radar: 'fa-solid fa-satellite-dish',
  rows: 'fa-solid fa-list',
  calendar: 'fa-solid fa-calendar-days',
  userGear: 'fa-solid fa-user-gear',
  users: 'fa-solid fa-users',
  clockHistory: 'fa-solid fa-clock-rotate-left',
  pause: 'fa-solid fa-pause',
  image: 'fa-regular fa-image',
  heart: 'fa-regular fa-heart',
  heartFull: 'fa-solid fa-heart',
  stepForward: 'fa-solid fa-forward-step',

  // meniul lateral al platformei
  chartLine: 'fa-solid fa-chart-line',
  dashboard: 'fa-solid fa-gauge-high',
  rocket: 'fa-solid fa-rocket',
  lightbulb: 'fa-solid fa-lightbulb',
  clipboard: 'fa-solid fa-clipboard-list',
  comments: 'fa-solid fa-comments',
  headset: 'fa-solid fa-headset',
  trophy: 'fa-solid fa-trophy',
  play: 'fa-solid fa-play-circle',
  broadcast: 'fa-solid fa-tower-broadcast',
  user: 'fa-solid fa-user-circle',
  medal: 'fa-solid fa-award',
  card: 'fa-solid fa-credit-card',
  book: 'fa-solid fa-book',
  lifeRing: 'fa-solid fa-life-ring',
  logout: 'fa-solid fa-right-from-bracket',

  // oformlenie
  palette: 'fa-solid fa-palette',
  candles: 'fa-solid fa-chart-simple',
  bitcoin: 'fa-brands fa-bitcoin',
  window: 'fa-regular fa-window-restore',
  send: 'fa-solid fa-paper-plane',
  key: 'fa-solid fa-key',
  shieldCheck: 'fa-solid fa-shield-halved',
  square: 'fa-regular fa-square',
  columns: 'fa-solid fa-table-columns',

  // acțiuni
  search: 'fa-solid fa-magnifying-glass',
  bookmark: 'fa-regular fa-bookmark',
  bookmarkOn: 'fa-solid fa-bookmark',
  bell: 'fa-solid fa-bell',
  camera: 'fa-solid fa-camera',
  share: 'fa-solid fa-share-nodes',
  expand: 'fa-solid fa-expand',
  fullscreen: 'fa-solid fa-up-right-and-down-left-from-center',
  compress: 'fa-solid fa-compress',
  plus: 'fa-solid fa-plus',
  close: 'fa-solid fa-xmark',
  check: 'fa-solid fa-check',
  chevronLeft: 'fa-solid fa-chevron-left',
  chevronRight: 'fa-solid fa-chevron-right',
  chevronDown: 'fa-solid fa-chevron-down',
  chevronUp: 'fa-solid fa-chevron-up',
  anglesLeft: 'fa-solid fa-angles-left',
  anglesRight: 'fa-solid fa-angles-right',
  arrowDown: 'fa-solid fa-arrow-down',
  arrowUp: 'fa-solid fa-arrow-up',
  refresh: 'fa-solid fa-arrow-rotate-right',
  trash: 'fa-solid fa-trash-can',
  pencil: 'fa-solid fa-pen',
  eyeOff: 'fa-solid fa-eye-slash',
  levels: 'fa-solid fa-grip-lines',
  penRuler: 'fa-solid fa-pen-ruler',
  textSlash: 'fa-solid fa-text-slash',
  help: 'fa-solid fa-circle-question',
  keyboard: 'fa-solid fa-keyboard',
  scrollMode: 'fa-solid fa-arrows-up-down',
  pageMode: 'fa-solid fa-table-cells-large',
  gear: 'fa-solid fa-gear',
  sliders: 'fa-solid fa-sliders',
  filter: 'fa-solid fa-filter',
  download: 'fa-solid fa-download',
  upload: 'fa-solid fa-upload',
  star: 'fa-regular fa-star',
  starOn: 'fa-solid fa-star',
  fire: 'fa-solid fa-fire',
  info: 'fa-solid fa-circle-info',
  warning: 'fa-solid fa-triangle-exclamation',
  lock: 'fa-solid fa-lock',
  magnet: 'fa-solid fa-magnet',
  undo: 'fa-solid fa-rotate-left',
  ellipsis: 'fa-solid fa-ellipsis',
  clock: 'fa-solid fa-clock',
  weight: 'fa-solid fa-weight-hanging',
  coins: 'fa-solid fa-coins',
  boxArchive: 'fa-solid fa-box-archive',
  bolt: 'fa-solid fa-bolt',
  layerGroup: 'fa-solid fa-layer-group',
  bug: 'fa-solid fa-bug',
};

/** Iconițele oferite la crearea unui filtru — sunt deja nume Font Awesome. */
const PASSTHROUGH = /^fa-/;

/** Unelte de desen: SVG propriu, ca la ScalpX (`chart-tool-svg`). */
const DRAW = {
  cursor: 'M5 3l14 8-6 1.5L10 19 5 3z',
  trend: 'M4 19L19 5m0 0h-6m6 0v6',
  hline: 'M3 12h18M8 12a1.6 1.6 0 103.2 0 1.6 1.6 0 10-3.2 0',
  hray: 'M7 12h14M5.4 12a1.6 1.6 0 103.2 0 1.6 1.6 0 10-3.2 0',
  vline: 'M12 3v18M12 10.4a1.6 1.6 0 100 3.2 1.6 1.6 0 100-3.2',
  ray: 'M7 17L20 4M5.4 18.6a1.6 1.6 0 102.3-2.3 1.6 1.6 0 10-2.3 2.3',
  arrow: 'M4 20L18 6m0 0h-6m6 0v6',
  rect: 'M4 6h16v12H4z',
  fib: 'M3 5h18M3 9.5h18M3 14.5h18M3 19h18',
  ruler: 'M4 10l6-6 10 10-6 6L4 10zm4-2l1.8 1.8M11 5.8l1.8 1.8M14 8.6l1.8 1.8',
  rr: 'M4 4h16v7H4zM4 13h16v7H4zM4 11.8h16',
  brush: 'M17 3l4 4-9.5 9.5-5 1.5 1.5-5L17 3zM5 16c-1.2 1.2-1 3.6-2 5 2.2-.4 4-.6 5-2',
  text: 'M4 4h16v3.5M12 5v14M8.5 19h7',
  eraser: 'M15 4l5 5-8.5 8.5H6L3 14.5 13 4.5zM7.5 12.5l4 4',
};

/** Iconițele de desen desenate cu contur. */
const STROKED = new Set(Object.keys(DRAW).filter((k) => k !== 'cursor'));

function svgIcon(name, size) {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', size);
  svg.setAttribute('height', size);
  svg.setAttribute('class', 'chart-tool-svg');
  svg.setAttribute('aria-hidden', 'true');
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', DRAW[name]);
  if (STROKED.has(name)) {
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.7');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
  } else {
    path.setAttribute('fill', 'currentColor');
  }
  svg.append(path);
  return svg;
}

/** Marcajul pentru butonul Tiger.Trade — pătrat, alb pe portocaliu. */
export function tigerMark(size = 14) {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', size);
  svg.setAttribute('height', size);
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('class', 'tiger-mark');
  for (const d of [
    'M3 3h6.2L6.6 6.6v6.8L3 17V3z',        // coloana stângă
    'M21 3h-6.2l2.6 3.6v6.8L21 17V3z',      // coloana dreaptă
    'M8.4 3h7.2L12 7.6 8.4 3z',             // crestătura de sus
    'M12 21.2 8.1 15.1h7.8L12 21.2z',       // triunghiul de jos
  ]) {
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', d);
    path.setAttribute('fill', 'currentColor');
    svg.append(path);
  }
  return svg;
}

/**
 * @param {string} name  nume semantic („search"), nume Font Awesome („fa-fire")
 *                       sau unealtă de desen („trend")
 * @param {number} size  dimensiunea în px
 */
export function icon(name, size = 16) {
  if (DRAW[name]) return svgIcon(name, size);

  const cls = FA[name] || (PASSTHROUGH.test(name) ? `fa-solid ${name}` : null);
  if (!cls) return svgIcon('cursor', size);

  const i = document.createElement('i');
  i.className = `${cls} icon`;
  i.style.fontSize = `${size}px`;
  i.setAttribute('aria-hidden', 'true');
  return i;
}

export const ICON_NAMES = Object.keys(FA);
